/**
 * Abre a aba que contem o primeiro erro de validacao.
 *
 * O problema que isto resolve nao aparece testando a tela com tudo preenchido.
 * Com o formulario dividido em abas, um campo invalido pode estar numa aba
 * fechada: o jquery-validate barra o envio, tenta focar um campo que nao esta
 * visivel, e a pessoa ve o botao voltar do estado de "Salvando..." sem nenhuma
 * mensagem na tela. Parece que o sistema engoliu o clique.
 *
 * Nao precisa de atributo na view: qualquer `.tab-pane` do Bootstrap ja e
 * coberto. E o unico contrato de marcacao e o proprio do Bootstrap — o gatilho
 * da aba aponta para o painel por `data-bs-target`.
 *
 * Dois momentos:
 *
 *   carga    - o erro veio do servidor e ja esta renderizado no HTML
 *   envio    - o jquery-validate barrou agora, do lado do cliente
 *
 * No envio, a leitura e adiada com `setTimeout(..., 0)` e le `defaultPrevented`
 * depois que o dispatch inteiro terminou. Mesmo motivo do `envio.ts`: a ordem
 * entre os handlers de `submit` depende de quem registrou primeiro, entao no
 * meio do dispatch ainda nao da para saber se alguem barrou.
 */

const SELETOR_ERRO = '.input-validation-error, .field-validation-error';

export function iniciarAbas(): void {
    ativarAbaComErro(document);

    document.addEventListener('submit', evento => {
        const formulario = evento.target;

        if (!(formulario instanceof HTMLFormElement)) return;

        setTimeout(() => {
            if (!evento.defaultPrevented) return;

            ativarAbaComErro(formulario);
        }, 0);
    });
}

function ativarAbaComErro(raiz: ParentNode): void {
    const erro = raiz.querySelector(SELETOR_ERRO);

    if (!erro) return;

    const painel = erro.closest('.tab-pane');

    if (!painel || painel.classList.contains('active')) return;

    const gatilho = document.querySelector<HTMLElement>(
        `[data-bs-toggle="tab"][data-bs-target="#${painel.id}"]`);

    if (!gatilho) return;

    (window as any).bootstrap.Tab.getOrCreateInstance(gatilho).show();

    // O jquery-validate ja tentou focar e falhou, porque o campo estava
    // escondido. Agora que a aba abriu, o foco pega — e sem ele a pessoa ve a
    // aba certa mas ainda tem de procurar qual campo reclamou.
    const campo = painel.querySelector<HTMLElement>('.input-validation-error');

    campo?.focus();
}
